if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        this.slides = Array.from(this.elements.viewer?.querySelectorAll('[data-media-id]') || []);
        this.currentIndex = 0;

        if (this.slides.length && !this.slides.some(el => el.classList.contains('is-active'))) {
          this.slides[0].classList.add('is-active');
        }

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

        this.elements.thumbnails?.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });

        if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails?.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const target = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!target) return;

        const viewerWrapper = this.elements.viewer;
        const viewerHeight = viewerWrapper.offsetHeight;
        viewerWrapper.style.minHeight = `${viewerHeight}px`;

        this.slides.forEach((el, index) => {
          el.classList.toggle('is-active', el.dataset.mediaId === mediaId);
          if (el === target) this.currentIndex = index;
        });

        if (prepend && target.parentElement.firstChild !== target) {
          target.parentElement.prepend(target);
        }

        this.preventStickyHeader();

        setTimeout(() => {
          const rect = target.getBoundingClientRect();
          if (rect.top <= -0.5) {
            const scrollTop = rect.top + window.scrollY;
            window.scrollTo({ top: scrollTop, behavior: 'smooth' });
          }
        }, 0);

        this.playActiveMedia(target);

        const image = target.querySelector('.product__modal-opener--image img');
        if (image) {
          const updatePosition = () => {
            this.elements.viewer.style.minHeight = '';
            centerArrowsToImage();
          };
          if (image.complete) {
            updatePosition();
          } else {
            image.onload = updatePosition;
            image.src = image.src;
          }
        }

        const activeThumbnail = this.elements.thumbnails?.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(target, activeThumbnail?.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!thumbnail || !this.elements.thumbnails) return;
        this.elements.thumbnails.querySelectorAll('button').forEach(btn =>
          btn.removeAttribute('aria-current')
        );
        thumbnail.querySelector('button')?.setAttribute('aria-current', true);
        if (!this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        this.stickyHeader?.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        this.elements.viewer.slider?.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems?.forEach((slide) =>
          slide.setAttribute('role', 'presentation')
        );
      }

      next() {
        const nextIndex = (this.currentIndex + 1) % this.slides.length;
        const nextId = this.slides[nextIndex].dataset.mediaId;
        this.setActiveMedia(nextId, false);
      }

      prev() {
        const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
        const prevId = this.slides[prevIndex].dataset.mediaId;
        this.setActiveMedia(prevId, false);
      }
    }
  );
}

function centerArrowsToImage() {
  const activeImage = document.querySelector('.product__media-wrapper .is-active img');
  const leftArrow = document.querySelector('.left-arrow');
  const rightArrow = document.querySelector('.right-arrow');
  if (!activeImage || !leftArrow || !rightArrow) return;

  const offset = activeImage.offsetTop + activeImage.offsetHeight / 2;
  leftArrow.style.top = `${offset}px`;
  rightArrow.style.top = `${offset}px`;
}

function initGalleryArrows() {
  const gallery = document.querySelector('media-gallery');
  const leftArrow = document.querySelector('.left-arrow');
  const rightArrow = document.querySelector('.right-arrow');
  const slides = document.querySelectorAll('.product__media-wrapper [data-media-id]');

  if (!gallery || !leftArrow || !rightArrow) return;

  if (slides.length <= 1) {
    leftArrow.style.display = 'none';
    rightArrow.style.display = 'none';
  } else {
    leftArrow.style.display = '';
    rightArrow.style.display = '';
  }

  leftArrow.addEventListener('click', () => {
    gallery.prev();
    setTimeout(() => gallery.prev(), 10);
  });

  rightArrow.addEventListener('click', () => {
    gallery.next();
    setTimeout(() => gallery.next(), 10);
  });

  document.querySelectorAll('.product__modal-opener').forEach((el) => {
    el.addEventListener('click', () => {
      leftArrow.style.display = 'none';
      rightArrow.style.display = 'none';
    });
  });

  let lastModalState = false;
  setInterval(() => {
    const modalOpen = document.querySelector('.media-modal[open], .product__modal[open]');
    const isOpen = !!modalOpen;
    if (!isOpen && lastModalState) {
      if (document.querySelectorAll('[data-media-id]').length > 1) {
        leftArrow.style.display = '';
        rightArrow.style.display = '';
        centerArrowsToImage();
      }
    }
    lastModalState = isOpen;
  }, 100);

  window.addEventListener('resize', centerArrowsToImage);
  centerArrowsToImage();

  // ✅ MutationObserver za automatsko centriranje kada se DOM promijeni
  const wrapper = document.querySelector('.product__media-wrapper');
  if (wrapper) {
    new MutationObserver(() => {
      setTimeout(centerArrowsToImage, 10);
    }).observe(wrapper, { childList: true, subtree: true });
  }
}

// Inicijalizacija na sve moguće Shopify evente
document.addEventListener('DOMContentLoaded', initGalleryArrows);
document.addEventListener('shopify:section:load', initGalleryArrows);
document.addEventListener('shopify:page:load', initGalleryArrows);
document.addEventListener('turbolinks:load', initGalleryArrows);














/*if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

document.addEventListener("DOMContentLoaded", function () {
  const gallery = document.querySelector('media-gallery');
  if (!gallery) return;

  const viewer = gallery.querySelector('[id^="GalleryViewer"]');
  const slider = viewer?.slider;
  const leftArrow = document.querySelector('.left-arrow');
  const rightArrow = document.querySelector('.right-arrow');

  if (!slider || !leftArrow || !rightArrow) return;

  leftArrow.addEventListener('click', () => {
    slider.prev();
  });

  rightArrow.addEventListener('click', () => {
    slider.next();
  });
});
*/
